import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatSnackBarModule } from '@angular/material/snack-bar'

import { SnackBarComponent } from './snack-bar.component'
import { MatIconModule } from '@angular/material/icon'

@NgModule({
  declarations: [SnackBarComponent],
  imports: [CommonModule, MatSnackBarModule, MatIconModule],
})
export class SnackBarModule {}
